document.addEventListener("DOMContentLoaded", function () {
  console.log("DOM loaded, setting up observer for Yotpo widget...");

  // Function to trigger load more
  function triggerLoadMore() {
    const loadMoreButton = document.querySelector(".yotpo-reviews-pagination-item");
    if (loadMoreButton && !loadMoreButton.classList.contains("loading")) {
      console.log("Found load more button, triggering load...");
      loadMoreButton.classList.add("loading");
      loadMoreButton.click();
      
      setTimeout(() => {
        loadMoreButton.classList.remove("loading");
      }, 2000);
    }
  }

  // Function to check scroll position and load more if needed
  function checkScrollAndLoad(reviewsList) {
    const scrollPosition = reviewsList.scrollLeft + reviewsList.clientWidth;
    const totalWidth = reviewsList.scrollWidth;
    const remainingScroll = totalWidth - scrollPosition;
    
    console.log('Scroll position:', {
      scrollLeft: reviewsList.scrollLeft,
      clientWidth: reviewsList.clientWidth,
      scrollWidth: reviewsList.scrollWidth,
      remainingScroll: remainingScroll
    });

    // If we're within 200px of the end
    if (remainingScroll < 200) {
      console.log('Near end of scroll, loading more reviews...');
      triggerLoadMore();
    }
  }

  // Function to check if reviews exist and add arrow
  function checkAndInitializeReviews() {
    setTimeout(() => {
      const emptyState = document.querySelector(".yotpo-empty-state-blank");
      const reviewsList = document.querySelector(".yotpo-reviews-list");
      
      if (emptyState && !reviewsList) {
        console.log("No reviews found, hiding section...");
        const section = emptyState.closest(".shopify-section");
        if (section) {
          section.style.display = "none";
        }
      } else if (reviewsList) {
        console.log("Reviews found, adding arrow...");
        addArrowButton(reviewsList);
        
        // Add scroll event listener
        reviewsList.addEventListener('scroll', () => {
          checkScrollAndLoad(reviewsList);
        });
      }
    }, 2000);
  }

  // Function to create and add arrow button
  function addArrowButton(reviewsList) {
    console.log("Adding arrow button...");

    const arrowButton = document.createElement("button");
    arrowButton.className = "custom-yotpo-next-reviews";
    arrowButton.innerHTML = ">";
    arrowButton.setAttribute("aria-label", "View more reviews");

    // Add click handler
    arrowButton.addEventListener("click", function () {
      // Calculate scroll amount (width of one review card + gap)
      const reviewCard = reviewsList.querySelector(".yotpo-review");
      if (!reviewCard) return;

      const cardWidth = reviewCard.offsetWidth;
      const scrollAmount = cardWidth + 20; // 20px for gap

      // Smooth scroll to next review
      reviewsList.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });

      // Check if we need to load more
      const scrollPosition = reviewsList.scrollLeft + reviewsList.clientWidth;
      const totalWidth = reviewsList.scrollWidth;
      const remainingScroll = totalWidth - scrollPosition;

      if (remainingScroll < cardWidth) {
        const loadMoreButton = document.querySelector(
          ".yotpo-reviews-pagination-item"
        );
        if (loadMoreButton && !loadMoreButton.classList.contains("loading")) {
          loadMoreButton.classList.add("loading");
          loadMoreButton.click();

          setTimeout(() => {
            loadMoreButton.classList.remove("loading");
          }, 2000);
        }
      }
    });

    // Add button to page
    reviewsList.parentElement.style.position = "relative";
    reviewsList.parentElement.appendChild(arrowButton);
  }

  // Initial observer for widget setup
  const initialObserver = new MutationObserver(function (mutations) {
    const reviewsList = document.querySelector(".yotpo-reviews-list");
    const emptyState = document.querySelector(".yotpo-empty-state-blank");
    
    if (reviewsList || emptyState) {
      console.log("Yotpo widget found!");
      initialObserver.disconnect();
      
      // Initialize reviews and arrow
      checkAndInitializeReviews();
    }
  });

  // Start initial observer
  initialObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Fallback timeout
  setTimeout(() => {
    if (initialObserver) {
      console.log("Observer disconnected after timeout");
      initialObserver.disconnect();
    }
  }, 10000);
});
